function dBFSToGain(dbfs) {
  return 10 ** (dbfs / 20);
}
function gainToDBFS(gain) {
  return 20 * Math.log10(gain);
}
const formatString = (num) => num.toString().padStart(2, "0");
const formatTimeforDVRDisplay = (seconds) => {
  const hoursLeft = formatString(Math.floor(seconds / 3600));
  const minutesLeft = formatString(Math.floor(seconds % 3600 / 60));
  const secondsLeft = formatString(Math.floor(seconds % 60));
  return `${hoursLeft !== "00" ? `${hoursLeft}:` : ""}${minutesLeft}:${secondsLeft}`;
};
const toPercentage = (pos, min, max) => {
  if (pos === "start") {
    return 0;
  } else if (pos === "end") {
    return 100;
  }
  return (pos - min) / (max - min) * 100;
};
export {
  dBFSToGain,
  formatTimeforDVRDisplay,
  gainToDBFS,
  toPercentage };
//# sourceMappingURL=dist/lib/videoUtils.js.map